import { Grid, IconButton, Tooltip } from '@material-ui/core'
import Programa from '../../components/Programa/Programa'
import React, { useCallback, useEffect, useState } from 'react'
import { MdArrowBack, MdDelete } from 'react-icons/md'
import { Cadastro } from './Cadastro'
import { metodoPrograma } from '../../components/api'
import Table from '../../components/Table/Table'
import { IoReload } from 'react-icons/io5'
import { format } from 'date-fns';

const Profiles = () => {
  const [lista, setLista] = useState([])
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [objeto, setObjeto] = useState([])

  const getLista = useCallback(() => {
    metodoPrograma('lista', {}).then((res) => {
      if (res.status) {
        if (res.lista) {
          setLista(res.lista)
        } else {
          setLista([])
        }
      }
    })
  }, [])

  const handleClick = (_, linha) => {
    setObjeto(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setTela('lista')
    setObjeto([])
    getLista()
  }

  useEffect(() => {
    getLista()
  }, [getLista])

  useEffect(() => {
    switch (tela) {
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const exclui = (idCategoria) => async (e) => {
      e.stopPropagation()
      if (
        !window.confirm(
          'Mas você tem CERTEZA que deseja ativar/inativar este registro?',
        )
      )
        return
      await metodoPrograma('exclui', { idCategoria })
      await getLista()
    }

  return (
    <Programa codigo="CtrlGestaoPerfil" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table
              dados={lista}
              head={['Nickname', 'Name', 'Total posts', 'Total reported', 'Total reports made', 'Inclusion', 'Deletion', '']}
              line={(l) => [l.perfil.cdPerfil, l.usuario.dsNome, l.post, l.denunciado, l.denunciou, l.usuario.dtInclusao !== null ? format(l.usuario.dtInclusao, 'MM/dd/yyyy - MM:SS') : '', l.usuario.dtExclusao !== null ? format(l.usuario.dtExclusao, 'MM/dd/yyyy - MM:SS') : '', '']}
              onClick={handleClick}
              columnOptions={[
                {
                  alias: 7,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small" onClick={exclui(linhaOriginal.usuario.idUsuario)}>
                      {linhaOriginal.usuario.dtExclusao ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
            />
          </Grid>
        </Grid>
      ) : (
        <Cadastro {...{ objeto, voltar }} />
      )}
    </Programa>
  )
}

export default Profiles